import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import BillingTab from '@/pages/settings/BillingTab';
import NotificationsTab from '@/pages/settings/NotificationsTab';
import ProfileTab from '@/pages/settings/ProfileTab';
import SecurityTab from '@/pages/settings/SecurityTab';
import { Bell, CreditCard, Lock, Shield, User, Users } from 'lucide-react';

const ComingSoonTab = ({ title, description }) => (
  <div className="text-center py-16">
    <div className="w-14 h-14 rounded-full bg-muted flex items-center justify-center mx-auto mb-4">
      <Lock className="w-6 h-6 text-muted-foreground" />
    </div>
    <h3 className="text-lg font-medium mb-2">{title}</h3>
    <p className="text-sm text-muted-foreground max-w-sm mx-auto">{description}</p>
    <span className="inline-block mt-4 px-3 py-1 rounded-full bg-muted text-xs font-medium text-muted-foreground">Coming Soon</span>
  </div>
);

const TAB_STYLE = "data-[state=active]:border-b-2 data-[state=active]:border-primary rounded-none";

const Settings = () => {
  return (
    <div data-testid="settings-page">
      <div className="page-header">
        <h1 className="page-title">Settings</h1>
        <p className="page-subtitle">Manage your account and preferences</p>
      </div>

      <div className="bg-card border border-border rounded-lg">
        <Tabs defaultValue="profile" className="w-full">
          <div className="border-b border-border px-6 overflow-x-auto">
            <TabsList className="bg-transparent h-auto p-0">
              <TabsTrigger value="profile" className={TAB_STYLE}>
                <User className="w-4 h-4 mr-2" />
                Profile
              </TabsTrigger>
              <TabsTrigger value="security" className={TAB_STYLE}>
                <Shield className="w-4 h-4 mr-2" />
                Security
              </TabsTrigger>
              <TabsTrigger value="billing" className={TAB_STYLE}>
                <CreditCard className="w-4 h-4 mr-2" />
                Billing
              </TabsTrigger>
              <TabsTrigger value="notifications" className={TAB_STYLE}>
                <Bell className="w-4 h-4 mr-2" />
                Notifications
              </TabsTrigger>
              <TabsTrigger value="team" className={TAB_STYLE}>
                <Users className="w-4 h-4 mr-2" />
                Team
              </TabsTrigger>
            </TabsList>
          </div>

          <div className="p-6">
            <TabsContent value="profile" className="mt-0">
              <ProfileTab />
            </TabsContent>

            <TabsContent value="security" className="mt-0">
              <SecurityTab />
            </TabsContent>

            <TabsContent value="billing" className="mt-0">
              <BillingTab />
            </TabsContent>

            <TabsContent value="notifications" className="mt-0">
              <NotificationsTab />
            </TabsContent>

            <TabsContent value="team" className="mt-0">
              <ComingSoonTab
                title="Team Management"
                description="Invite colleagues, assign roles, and manage team permissions. Available for Accounting Firm and Group Company plans."
              />
            </TabsContent>
          </div>
        </Tabs>
      </div>
    </div>
  );
};

export default Settings;
